module.exports = __webpack_public_path__ + "img/error.cc7844cb.png";